import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./loan-features.css";
import { FaShieldAlt, FaChartLine, FaClock, FaHandshake, FaLockOpen, FaCreditCard } from "react-icons/fa";

const featureData = [
  {
    key: "secure",
    icon: <FaShieldAlt />,
    title: "Secure & Compliant",
    description: "Your data is protected with bank-grade encryption and strict regulatory compliance.",
    color: "#00ff7f", // Neon Green
  },
  {
    key: "transparent",
    icon: <FaChartLine />,
    title: "Transparent Terms",
    description: "No hidden fees, no surprises. Understand every aspect of your loan upfront with clear documentation.",
    color: "#d50ac6", // Magenta
  },
  {
    key: "quick",
    icon: <FaClock />,
    title: "Quick Approval",
    description: "Get instant decisions and access funds within minutes, avoiding lengthy waiting periods.",
    color: "#ecd969", // Gold/Yellowish
  },
  {
    key: "flexible",
    icon: <FaHandshake />,
    title: "Flexible Repayment",
    description: "Tailor your repayment schedule to fit your financial comfort and needs, easily managed online.",
    color: "#00ffd5", // Aqua Green
  },
];

const LoanFeaturesList = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeFeature = featureData[activeIndex];

  // Auto-cycle through features every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % featureData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="lfl-wrap">
      {/* Dynamic Background Glow based on active feature */}
      <div 
        className="lfl-bg-glow" 
        style={{ background: `radial-gradient(circle at 10% 50%, ${activeFeature.color}30, transparent 70%)` }}
      ></div>

      <div className="lfl-container">
        <div className="lfl-eyebrow">Key Advantages</div>
        <h2 className="lfl-title">
          Experience  <span className="lfl-highlight"> the Future </span>of Lending
        </h2>

        <div className="lfl-content-grid">
          {/* LEFT SIDE: Feature List */}
          <div className="lfl-list-side">
            {featureData.map((feature, index) => (
              <div
                key={feature.key}
                className={`lfl-list-item ${activeIndex === index ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="lfl-list-icon" style={{ color: feature.color }}>
                  {feature.icon}
                </div>
                <span className="lfl-list-title">{feature.title}</span>
                {/* Active glow line */}
                <div className="lfl-active-line" style={{ background: feature.color }}></div>
              </div>
            ))}
          </div>

          {/* RIGHT SIDE: 3D Highlight/Display Area */}
          <div className="lfl-display-side">
            <div className="lfl-display-box">
              <div className="lfl-display-visual">
                {/* Three.js-inspired floating element/visual */}
                <div 
                  className="lfl-floating-visual"
                  style={{ 
                    '--visual-color': activeFeature.color,
                    '--visual-shadow': `${activeFeature.color}99`
                  }}
                >
                  {activeFeature.icon}
                </div>
              </div>
              
              <h3 className="lfl-display-title">{activeFeature.title}</h3>
              <p className="lfl-display-description">{activeFeature.description}</p>
              
         <Link to="/apply-now">
  <button className="ec-btn-primary">Apply Now</button>
</Link>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanFeaturesList;